module.exports = __webpack_public_path__ + "static/img/成四-廖進吉.92b0e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成四-廖進吉.jpg
// module id = HmaX
// module chunks = 1